// Servicio de detección de país por IP del visitante.
// Independiente del backend de Somit: se usa antes de cualquier login,
// cuando aún no existe sesión ni datos del cliente.

const GEO_API_URL = "https://ipinfo.io/json";

export async function obtenerPaisPorIp() {
  try {
    // REACT_APP_IPINFO_TOKEN es opcional: sin token, ipinfo.io responde
    // igual pero con un límite de peticiones compartido más bajo.
    const token = process.env.REACT_APP_IPINFO_TOKEN;
    const url = token ? `${GEO_API_URL}?token=${token}` : GEO_API_URL;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Geo API respondió ${response.status}`);
    }
    const data = await response.json();
    const codigoPais = (data && data.country) || "";

    return codigoPais ? codigoPais.toUpperCase() : null;
  } catch (error) {
    // Si el servicio de geolocalización falla no se puede confirmar el país
    // del visitante, así que se retorna null (el Footer se mantiene oculto).
    return null;
  }
}
